<template>
    <div>
        <b-table hover :items="taskList" :fields="fields" responsive="true" :small="true" @row-clicked="onRowClicked">
            <template v-slot:cell(enabled)="data">
                <b-icon v-if="data.value" icon="check" variant="success" scale="1.5" />
                <b-icon v-else icon="x" variant="danger" scale="1.5" />
            </template>
        </b-table>
    </div>
</template>

<script>
import scheduledTask from '@/store/system/scheduledTask'
import moment from 'moment'

export default {
    computed: {
        taskList() {
            return this.$store.state.scheduledTask.scheduledTaskList;
        },
        fields() {
            return [
                { key: "scheduledTaskId", label: this.$t('scheduled_tasks.id') },
                { key: "description", label: this.$t('scheduled_tasks.description'), sortable: true },
                { key: "enabled", label: this.$t('scheduled_tasks.enabled') },
                { key: "taskType", label: this.$t('scheduled_tasks.task_type'),
                    formatter: value => this.$t('scheduled_tasks.type.'+ value)
                },
                { key: "scheduleType", label: this.$t('scheduled_tasks.schedule_type'),
                    formatter: value => this.$t('scheduled_tasks.schedule.'+ value)
                },
                { key: "lastRunStarted", label: this.$t('scheduled_tasks.last_run'), sortable: true,
                    formatter: function(value) {
                        var time = new moment(value, "YYYY-MM-DD[T]HH:mm:ss.SSSZZ").format("DD.MM.YYYY HH:mm");
                        if (time.startsWith('Invalid')) {
                            return "";
                        }
                        return time;
                    }
                },
                { key: "nextRun", label: this.$t('scheduled_tasks.next_run'), sortable: true,
                    formatter: function(value) {
                        var time = new moment(value, "YYYY-MM-DD[T]HH:mm:ss.SSSZZ").format("DD.MM.YYYY HH:mm");
                        if (time.startsWith('Invalid')) {
                            return "";
                        }
                        return time;
                    }
                }
            ];
        }
    },
    beforeCreate: function() {
        if (!this.$store.state.scheduledTask) {
            this.$store.registerModule("scheduledTask", scheduledTask);
        }
        this.$store.dispatch('scheduledTask/getScheduledTaskList');
    },
    methods: {
        onRowClicked(item) {
            //this.$store.commit('scheduledTask/changeSelectedTask', item);
            this.$store.dispatch('scheduledTask/selectTask', item);
        }
    }
}
</script>